import React from 'react';
import { motion } from 'framer-motion';
import CircularProgress from './CircularProgress';

const chartData = [
  { percentage: 89, label: 'AI usage invisible to organizations' },
  { percentage: 71, label: 'Sessions through personal accounts' },
  { percentage: 18, label: 'Employees paste company data into AI' },
];

const GovernanceCrisisSection = () => {
  return (
    <div className="w-full">
      {/* Bigger grid spacing and larger circles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
        {chartData.map((data, index) => (
          <div key={index} className="flex flex-col items-center">
            {/* Pass bigger size to CircularProgress */}
            <CircularProgress 
              percentage={data.percentage} 
              label={data.label} 
              size={220}       // 👈 bump this (e.g. 220px)
              strokeWidth={16} // 👈 thicker stroke
            />
            <p className="mt-6 text-xl font-semibold text-center max-w-xs">
              {data.label}
            </p>
          </div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="text-xl text-muted-foreground max-w-3xl mx-auto text-center mb-12 leading-relaxed"
      >
        Organizations have zero visibility into most AI usage, creating a compliance vacuum. Nearly one in five employees paste
        company data into AI systems, half of it sensitive, while most activity occurs through personal accounts without corporate
        oversight.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        className="p-8 border-2 rounded-xl border-destructive/40 bg-destructive/10 text-destructive-foreground/90 max-w-3xl mx-auto shadow-lg"
      >
        <p className="text-xl italic text-center text-foreground">
          <span className="font-bold text-destructive mr-2 text-2xl">⚠️</span>
          Shadow AI contributed ~CA$308,000 in additional cost per breach in the past year, compounding privacy and
          compliance exposure.
        </p>
      </motion.div>
    </div>
  );
};

export default GovernanceCrisisSection;
